import { createRef, useEffect, useState } from 'react'
import type { MouseEvent } from 'react'
import { Link } from 'react-router-dom'

import { Burger } from '../Burger'
import { useAppState } from '../../context/AppContext'

import './Header.styles.scss'

import Logo from '@assets/landing-page-v3/header/logo.svg'
import ToggleArrow from '@assets/landing-page-v3/header/toggleArrow.svg'
import Discord from '@assets/landing-page-v3/logos/Discord.svg'
import Twitter from '@assets/landing-page-v3/logos/Twitter.svg'
import OpenSea from '@assets/landing-page-v3/logos/OpenSea.svg'

function AboutLink({ headerOpened }: { headerOpened: boolean }) {
  const appState = useAppState()

  const [ headerDropdownOpened, setHeaderDropdownOpened ] = useState(false)
  const HeaderDropdownRef = createRef<HTMLDivElement>()

  useEffect(() => {
    if (!HeaderDropdownRef.current) { return }
    if (window.innerWidth > 699) { return }

    if (headerDropdownOpened) {
      HeaderDropdownRef.current.style.height = `${HeaderDropdownRef.current.scrollHeight}px`
      HeaderDropdownRef.current.parentElement.classList.add('open')
    } else {
      HeaderDropdownRef.current.style.height = null
      HeaderDropdownRef.current.parentElement.classList.remove('open')
    }
  }, [ headerDropdownOpened ])

  useEffect(() => {
    if (!headerOpened) {
      setHeaderDropdownOpened(false)
    }
  }, [headerOpened])

  if (
    !appState.features.showWhitepaperLink &&
    !appState.features.showMapLink &&
    !appState.features.showContactsSection
  ) {
    return <a href={'/#about'}>About</a>
  }

  return (
    <span className='DropdownLink'>
      <span onClick={() => setHeaderDropdownOpened(!headerDropdownOpened)}>About <img src={ToggleArrow} /></span>

      <div className='HeaderDropdown' ref={HeaderDropdownRef}>
        {appState.features.showWhitepaperLink && <Link to={'/whitepaper'}>Whitepaper</Link>}
        {appState.features.showMapLink && <Link to={'/maps'}>Maps</Link>}
        {appState.features.showContactsSection && (
          <a href={'/#contact'}>Contact</a>
        )}
      </div>
    </span>
  )
}

export function Header() {
  const [ opened, setOpened ] = useState(false)

  const headerClicked = (event: MouseEvent<HTMLElement>) => {
    const target = event.target as HTMLElement

    if(!['NAV', 'DIV'].includes(target.nodeName)) {
      return
    }

    setOpened(false)
  }

  return (
    <nav className={`Header ${opened ? 'open' : ''}`} onClick={headerClicked}>
      <Link to={'/'}>
        <img src={Logo} alt='Storyverse Logo' className={'Logo'} /> 
      </Link>

      <div className={'LinkContainer'}>
        <Link to={'/create'}>Create</Link>
        <AboutLink headerOpened={opened} />
        <a href={'/#roadmap'}>Roadmap</a>
        <a href={'/#faq'}>FAQ</a>

        <div className='IconContainer'>
          <a href={'https://discord.com/invite/storyverse'} target='_blank'>
            <img src={Discord} alt='Discord' />
          </a>
          <a href={'https://twitter.com/storyverse_xyz'} target='_blank'>
            <img src={Twitter} alt='Twitter' />
          </a>
          <a href={'https://opensea.io/collection/storyverse-plots'} target='_blank'>
            <img src={OpenSea} alt='OpenSea' />
          </a>
        </div>
      </div>

      <Burger className={'Burger'} opened={opened} onClick={() => setOpened(!opened)} />
    </nav>
  )
}
